import template from './sidebar.pug';
import controller from './sidebar.controller';

const SidebarComponent = {
  template,
  controller,
};

export default SidebarComponent;



// WEBPACK FOOTER //
// ./client/app/reports/sidebar/sidebar.component.js